// Labor and parts quick-select in the op panel (the wrench by "Work performed" and the parts button):
// lists from /quickSelect/labor and /quickSelect/parts, search, and picking an item.
// Split out of app.js (docs/split-plan.md, session 3). addParts comes in through setQuickSelectDeps()
// (see estimates.js for why it doesn't import app.js back).
import { database } from './initFirebase';
import { searchGeneralInventory } from './partSearch';
import { get, ref } from 'firebase/database';

let shell = null;
export function setQuickSelectDeps(deps) { shell = deps; }

document.getElementById('myPartsSelectInput').addEventListener('input', searchGeneralInventory)

export async function renderPartsData() {
  if (!navigator.onLine) {
    console.log('User is offline. Skipping function.');
    return;
  }

  try {
    const partsRef = ref(database, 'quickSelect/parts');
    const snapshot = await get(partsRef);
    const data = snapshot.val();
    const container = document.getElementById("partsQS");

    if (!data) {
      console.log("No parts data available.");
      return;
    }

    container.innerHTML = '';

    function renderCategory(parentContainer, categoryData, level = 1) {
      Object.keys(categoryData).forEach((key) => {
        const items = categoryData[key];

        const categoryContainer = document.createElement("div");
        categoryContainer.className = "category-container";
        if (level === 1) {
          categoryContainer.classList.add("level-1");
          categoryContainer.setAttribute("data-category", key);
        }

        const header = document.createElement(level === 1 ? "h2" : level === 2 ? "h3" : "h4");
        header.className = level === 1 ? "form-header2" : level === 2 ? "form-subheader" : "form-header3";
        header.innerText = key;
        categoryContainer.appendChild(header);


        if (Array.isArray(items)) {
          const ul = document.createElement("ul");
          ul.className = 'ul-item';
          items.forEach(item => {
            if (item) appendListItem(ul, item, "Parts");
          });
          categoryContainer.appendChild(ul);
        } else if (typeof items === "object" && items !== null) {
          renderCategory(categoryContainer, items, level + 1);
        }

        parentContainer.appendChild(categoryContainer);
      });
    }

    renderCategory(container, data);

  } catch (error) {
    console.error("Error fetching parts data:", error);
  }
}

export async function renderLaborData() {
  if (!navigator.onLine) {
    console.log('User is offline. Skipping function.');
    return;
  }

  try {
    const laborRef = ref(database, 'quickSelect/labor'); // Adjust this path if necessary
    const snapshot = await get(laborRef);
    const data = snapshot.val();
    const container = document.getElementById("laborQS");

    if (!data) {
      console.warn('No labor data available.');
      return;
    }

    function appendCategoryData(parentElement, categoryData, level = 1) {
      Object.keys(categoryData).forEach((key) => {
        const header = document.createElement(level === 1 ? "h2" : "h3");
        header.className = level === 1 ? "form-header2" : "form-subheader";
        header.innerText = key;

        const div = document.createElement("div");

        if(level === 1){
        div.className = `category-container-${key}`;
        div.dataset.category = key; // names with spaces ("Bottom Paint") can't be read back from the class
        }else{
          div.className = `category-subcontainer-${key}`;
        }

        div.appendChild(header);

        div.appendChild(header);

        const ul = document.createElement("ul");
        ul.className = 'ul-item';
        div.appendChild(ul);

        parentElement.appendChild(div);

        const items = categoryData[key];

        if (Array.isArray(items)) {
          items.forEach(item => appendListItem(ul, item, "Labor"));
        } else if (typeof items === "object") {
          appendCategoryData(ul, items, level + 1);
        }
      });
    }

    appendCategoryData(container, data);
  } catch (error) {
    console.error("Error fetching labor data:", error);
  }
}

function appendListItem(ul, item, category) {
  const li = document.createElement("li");
  li.className = "list-item";
  li.innerText = `${item}`;
  li.addEventListener('click', (e) => {
    if (category === "Parts") {
      const part = e.target.innerHTML;
      shell.addParts(part);
    }

    if(category === "Labor"){
      const labor = e.target.innerHTML;
      const laborEntryElement = document.getElementById('labor-entry-description');
      const currentLabor = laborEntryElement.value;

      if (e.target.classList.contains('highlighted')) {
        // Remove highlight and remove from labor entry
        e.target.classList.remove('highlighted');
        const laborArray = currentLabor.split('  ');
        const updatedLabor = laborArray.filter(item => item !== labor).join('  ');
        laborEntryElement.value = updatedLabor;
      } else {
        // Add highlight and add to labor entry
        e.target.classList.add('highlighted');
        if (currentLabor === '') {
          laborEntryElement.value = labor;
        } else {
          laborEntryElement.value = currentLabor + '  ' + labor;
        }
      }
    }
  });
  ul.appendChild(li);
}

document.getElementById('searchBarQS').addEventListener('input', () => {
  filterLaborQS();
  filterPartsQS();
});

function filterLaborQS() {
  var input = document.getElementById("searchBarQS");
  var filter = input.value.trim().toLowerCase();
  var container = document.getElementById("laborQS");
  var headers = container.getElementsByClassName("form-header2");

  for (var i = 0; i < headers.length; i++) {
    var header = headers[i];
    var ul = header.nextElementSibling;
    var hasMatchingItem = false;

    // If this header has a UL or nested subcategories
    if (ul && ul.tagName.toLowerCase() === "ul") {
      var listItems = ul.getElementsByTagName("li");

      for (var j = 0; j < listItems.length; j++) {
        var listItemText = listItems[j].textContent || listItems[j].innerText;

        if (listItemText.toLowerCase().includes(filter)) {
          hasMatchingItem = true;
          listItems[j].style.display = "block"; // Show matching items
        } else {
          listItems[j].style.display = "none"; // Hide non-matching items
        }
      }
    } else if (ul && ul.tagName.toLowerCase() === "div") {
      // If it's a nested subcategory container
      var subHeaders = ul.getElementsByClassName("form-subheader");
      for (var k = 0; k < subHeaders.length; k++) {
        var subHeader = subHeaders[k];
        var subUl = subHeader.nextElementSibling;
        var hasSubMatchingItem = false;

        if (subUl && subUl.tagName.toLowerCase() === "ul") {
          var subListItems = subUl.getElementsByTagName("li");

          for (var m = 0; m < subListItems.length; m++) {
            var subListItemText = subListItems[m].textContent || subListItems[m].innerText;

            if (subListItemText.toLowerCase().includes(filter)) {
              hasSubMatchingItem = true;
              subListItems[m].style.display = "block";
            } else {
              subListItems[m].style.display = "none";
            }
          }
        }

        if (hasSubMatchingItem) {
          subHeader.style.display = "block";
          if (subUl) subUl.style.display = "block";
          hasMatchingItem = true;
        } else {
          subHeader.style.display = "none";
          if (subUl) subUl.style.display = "none";
        }
      }
    }

    // Show or hide the main header
    if (hasMatchingItem) {
      header.style.display = "block";
      if (ul) ul.style.display = "block";
    } else {
      header.style.display = "none";
      if (ul) ul.style.display = "none";
    }
  }
}

function filterPartsQS() {
  var input = document.getElementById("searchBarQS");
  var filter = input.value.trim().toLowerCase();
  var container = document.getElementById("partsQS");

  function filterCategory(categoryContainer, level) {
    var headers = categoryContainer.getElementsByClassName(level === 1 ? "form-header2" : level === 2 ? "form-subheader" : "form-header3");
    var hasCategoryMatch = false;

    for (var i = 0; i < headers.length; i++) {
      var header = headers[i];
      var ul = header.nextElementSibling;
      var hasMatchingItem = false;

      if (ul && ul.tagName.toLowerCase() === "ul") {
        var listItems = ul.getElementsByTagName("li");

        for (var j = 0; j < listItems.length; j++) {
          var listItemText = listItems[j].textContent || listItems[j].innerText;

          if (listItemText.toLowerCase().includes(filter)) {
            hasMatchingItem = true;
            listItems[j].style.display = "block";
          } else {
            listItems[j].style.display = "none";
          }
        }
      } else if (ul && ul.tagName.toLowerCase() === "div") {
        // Nested categories
        hasMatchingItem = filterCategory(ul, level + 1);
      }

      if (hasMatchingItem) {
        header.style.display = "block";
        if (ul) ul.style.display = "block";
        hasCategoryMatch = true;
      } else {
        header.style.display = "none";
        if (ul) ul.style.display = "none";
      }
    }
    return hasCategoryMatch;
  }

  filterCategory(container, 1);
}

// Which top-level categories to show for the open op's type: the one named like it ("Moorings" and
// "Mooring" match), or every category when none is (most op types have no category of their own;
// showing only an exact match left Electrical, Winterizing, General Labor... with an empty list).
function categoriesToShow(categories) {
  const norm = s => String(s || '').trim().toLowerCase().replace(/s$/, '');
  const opType = norm(document.getElementById('updateOpType').value);
  const matched = categories.filter(c => norm(c.dataset.category) === opType);
  return new Set(matched.length ? matched : categories);
}

function filterLaborCategories() {
  const categoryContainers = [...document.querySelectorAll('#laborQS [data-category]')];
  const show = categoriesToShow(categoryContainers);
  categoryContainers.forEach(container => {
    container.style.display = show.has(container) ? 'block' : 'none';
  });
}

document.getElementById('openLaborQS').addEventListener('click', () => {
  document.getElementById('laborAndPartsQS').classList.toggle('qs-open');
  document.getElementById('laborQS').style.display = "flex";
  document.getElementById('partsQS').style.display = "none";
  document.getElementById('searchBarQS').focus()

  filterLaborCategories();
})

document.getElementById('openPartsQS').addEventListener('click', () => {
  document.getElementById('laborAndPartsQS').classList.toggle('qs-open');
  document.getElementById('laborQS').style.display = "none";
  document.getElementById('partsQS').style.display = "flex";
  document.getElementById('searchBarQS').focus()

  const categories = [...document.querySelectorAll('#partsQS .category-container.level-1')];
  const show = categoriesToShow(categories);
  categories.forEach(category => category.classList.toggle('hidden', !show.has(category)));
})

document.getElementById('qs-return').addEventListener('click', () => {
  document.getElementById('laborAndPartsQS').classList.toggle('qs-open');
  document.getElementById('searchBarQS').value = '';
  document.querySelectorAll('.ul-item .list-item').forEach(item => item.classList.remove('highlighted'));
});
